import React, { useEffect, useState } from "react";
import { api } from "../lib/ccsApi";

let cached = null;

export function usePublicConfig() {
    const [cfg, setCfg] = useState(cached);
    useEffect(() => {
        if (cached) return;
        api.get("/config").then((r) => { cached = r.data; setCfg(r.data); }).catch(() => {});
    }, []);
    return cfg || { support_email: "support@calculatemyccs.com.au", donation_url: "https://buymeacoffee.com/placeholder" };
}
